module.exports = __webpack_public_path__ + "static/media/notification.0aaf1f80.svg";